var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _g2, _g3, _g4, _g5, _g6, _circle, _circle2, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g7, _g8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrinciples2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.998 52.4961C44.3333 52.4961 52.4961 41.5279 52.4961 27.998C52.4961 14.4681 44.3333 3.5 27.998 3.5C11.6628 3.5 3.5 14.4681 3.5 27.998C3.5 41.5279 11.6628 52.4961 27.998 52.4961Z",
    fill: "url(#paint0_radial_713_10137)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.998 52.4961C44.3333 52.4961 52.4961 41.5279 52.4961 27.998C52.4961 14.4681 44.3333 3.5 27.998 3.5C11.6628 3.5 3.5 14.4681 3.5 27.998C3.5 41.5279 11.6628 52.4961 27.998 52.4961Z",
    fill: "url(#paint1_radial_713_10137)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.998 52.4961C44.3333 52.4961 52.4961 41.5279 52.4961 27.998C52.4961 14.4681 44.3333 3.5 27.998 3.5C11.6628 3.5 3.5 14.4681 3.5 27.998C3.5 41.5279 11.6628 52.4961 27.998 52.4961Z",
    fill: "url(#paint2_radial_713_10137)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.998 52.4961C44.3333 52.4961 52.4961 41.5279 52.4961 27.998C52.4961 14.4681 44.3333 3.5 27.998 3.5C11.6628 3.5 3.5 14.4681 3.5 27.998C3.5 41.5279 11.6628 52.4961 27.998 52.4961Z",
    fill: "url(#paint3_radial_713_10137)",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.998 52.4961C44.3333 52.4961 52.4961 41.5279 52.4961 27.998C52.4961 14.4681 44.3333 3.5 27.998 3.5C11.6628 3.5 3.5 14.4681 3.5 27.998C3.5 41.5279 11.6628 52.4961 27.998 52.4961Z",
    fill: "url(#paint4_radial_713_10137)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.998 52.4961C44.3333 52.4961 52.4961 41.5279 52.4961 27.998C52.4961 14.4681 44.3333 3.5 27.998 3.5C11.6628 3.5 3.5 14.4681 3.5 27.998C3.5 41.5279 11.6628 52.4961 27.998 52.4961Z",
    fill: "url(#paint5_radial_713_10137)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.998 52.4961C44.3333 52.4961 52.4961 41.5279 52.4961 27.998C52.4961 14.4681 44.3333 3.5 27.998 3.5C11.6628 3.5 3.5 14.4681 3.5 27.998C3.5 41.5279 11.6628 52.4961 27.998 52.4961Z",
    fill: "url(#paint6_radial_713_10137)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.998 52.4961C44.3333 52.4961 52.4961 41.5279 52.4961 27.998C52.4961 14.4681 44.3333 3.5 27.998 3.5C11.6628 3.5 3.5 14.4681 3.5 27.998C3.5 41.5279 11.6628 52.4961 27.998 52.4961Z",
    fill: "url(#paint7_radial_713_10137)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_713_10137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6974 44.6621L47.2759 44.0951L42.3473 37.6741L39.8945 41.7697L46.6974 44.6621Z",
    fill: "url(#paint8_linear_713_10137)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_713_10137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1348 10.1267C31.1348 10.1267 32.8471 8.76147 35.4617 8.76147C38.0764 8.76147 40.2052 10.3581 40.2052 10.3581",
    stroke: "#D46A37",
    strokeOpacity: 0.6,
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_713_10137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.252 13.6889C12.252 13.6889 13.9642 12.3237 16.5789 12.3237C19.1936 12.3237 21.3224 13.9203 21.3224 13.9203",
    stroke: "#AC552B",
    strokeOpacity: 0.6,
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_713_10137)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.6689,
    cy: 22.7743,
    r: 9.20989,
    fill: "#CD6330",
    fillOpacity: 0.6
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_713_10137)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.0664,
    cy: 21.6262,
    r: 7.18356,
    fill: "#D56A37",
    fillOpacity: 0.6
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_713_10137)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3707 19.9082C44.6466 19.9082 44.8703 20.3783 44.8703 20.9582V44.4738C44.8703 45.0537 44.6466 45.5238 44.3707 45.5238C44.0948 45.5238 43.8711 45.0537 43.8711 44.4738V20.9582C43.8711 20.3783 44.0948 19.9082 44.3707 19.9082Z",
    fill: "#DF7644"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5449,
    cy: 20.8652,
    r: 7.79297,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.8848,
    cy: 20.9473,
    r: 7.38281,
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.752 14.4395C33.8518 14.4395 31.502 16.7893 31.502 19.6895C31.502 22.5897 33.8518 24.9395 36.752 24.9395C39.6522 24.9395 42.002 22.5897 42.002 19.6895C42.002 16.7893 39.6522 14.4395 36.752 14.4395ZM17.502 14.877C14.6018 14.877 12.252 17.2268 12.252 20.127C12.252 23.0272 14.6018 25.377 17.502 25.377C20.4022 25.377 22.752 23.0272 22.752 20.127C22.752 17.2268 20.4022 14.877 17.502 14.877Z",
    fill: "#402A32"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9336 11.5732C13.9336 11.5732 15.4608 10.2495 18.1927 10.2495C21.1067 10.2495 22.819 11.8046 22.819 11.8046",
    stroke: "url(#paint9_radial_713_10137)",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0918 7.64547C33.0918 7.64547 34.8041 6.28027 37.4188 6.28027C40.0334 6.28027 42.1623 7.87687 42.1623 7.87687",
    stroke: "url(#paint10_radial_713_10137)",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4497 33.9141C31.4497 33.9141 29.5397 36.2605 25.9159 36.1268C22.8967 36.0153 20.9988 33.6553 20.9988 33.6553",
    stroke: "url(#paint11_radial_713_10137)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8703 19.9082C48.4502 19.9082 48.9203 20.3783 48.9203 20.9582V44.4738C48.9203 45.0537 48.4502 45.5238 47.8703 45.5238C47.2904 45.5238 46.8203 45.0537 46.8203 44.4738V20.9582C46.8203 20.3783 47.2904 19.9082 47.8703 19.9082Z",
    fill: "url(#paint12_linear_713_10137)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8703 19.9082C48.4502 19.9082 48.9203 20.3783 48.9203 20.9582V44.4738C48.9203 45.0537 48.4502 45.5238 47.8703 45.5238C47.2904 45.5238 46.8203 45.0537 46.8203 44.4738V20.9582C46.8203 20.3783 47.2904 19.9082 47.8703 19.9082Z",
    fill: "url(#paint13_linear_713_10137)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8703 19.9082C48.4502 19.9082 48.9203 20.3783 48.9203 20.9582V44.4738C48.9203 45.0537 48.4502 45.5238 47.8703 45.5238C47.2904 45.5238 46.8203 45.0537 46.8203 44.4738V20.9582C46.8203 20.3783 47.2904 19.9082 47.8703 19.9082Z",
    fill: "url(#paint14_linear_713_10137)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6069 22.8073C47.3826 22.8973 47.1939 23.0738 47.1344 23.308C46.0468 27.5903 42.166 30.7581 37.5453 30.7581C32.0816 30.7581 27.6523 26.3289 27.6523 20.8651C27.6523 15.4014 32.0816 10.9722 37.5453 10.9722C42.166 10.9722 46.0468 14.14 47.1344 18.4223C47.1939 18.6565 47.3826 18.833 47.6069 18.9229C48.3767 19.2317 48.9203 19.9849 48.9203 20.8651C48.9203 21.7453 48.3767 22.4985 47.6069 22.8073ZM45.3383 20.8651C45.3383 25.1691 41.8493 28.6581 37.5453 28.6581C33.2414 28.6581 29.7523 25.1691 29.7523 20.8651C29.7523 16.5612 33.2414 13.0722 37.5453 13.0722C41.8493 13.0722 45.3383 16.5612 45.3383 20.8651Z",
    fill: "url(#paint15_radial_713_10137)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6069 22.8073C47.3826 22.8973 47.1939 23.0738 47.1344 23.308C46.0468 27.5903 42.166 30.7581 37.5453 30.7581C32.0816 30.7581 27.6523 26.3289 27.6523 20.8651C27.6523 15.4014 32.0816 10.9722 37.5453 10.9722C42.166 10.9722 46.0468 14.14 47.1344 18.4223C47.1939 18.6565 47.3826 18.833 47.6069 18.9229C48.3767 19.2317 48.9203 19.9849 48.9203 20.8651C48.9203 21.7453 48.3767 22.4985 47.6069 22.8073ZM45.3383 20.8651C45.3383 25.1691 41.8493 28.6581 37.5453 28.6581C33.2414 28.6581 29.7523 25.1691 29.7523 20.8651C29.7523 16.5612 33.2414 13.0722 37.5453 13.0722C41.8493 13.0722 45.3383 16.5612 45.3383 20.8651Z",
    fill: "url(#paint16_linear_713_10137)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6069 22.8073C47.3826 22.8973 47.1939 23.0738 47.1344 23.308C46.0468 27.5903 42.166 30.7581 37.5453 30.7581C32.0816 30.7581 27.6523 26.3289 27.6523 20.8651C27.6523 15.4014 32.0816 10.9722 37.5453 10.9722C42.166 10.9722 46.0468 14.14 47.1344 18.4223C47.1939 18.6565 47.3826 18.833 47.6069 18.9229C48.3767 19.2317 48.9203 19.9849 48.9203 20.8651C48.9203 21.7453 48.3767 22.4985 47.6069 22.8073ZM45.3383 20.8651C45.3383 25.1691 41.8493 28.6581 37.5453 28.6581C33.2414 28.6581 29.7523 25.1691 29.7523 20.8651C29.7523 16.5612 33.2414 13.0722 37.5453 13.0722C41.8493 13.0722 45.3383 16.5612 45.3383 20.8651Z",
    fill: "url(#paint17_radial_713_10137)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6069 22.8073C47.3826 22.8973 47.1939 23.0738 47.1344 23.308C46.0468 27.5903 42.166 30.7581 37.5453 30.7581C32.0816 30.7581 27.6523 26.3289 27.6523 20.8651C27.6523 15.4014 32.0816 10.9722 37.5453 10.9722C42.166 10.9722 46.0468 14.14 47.1344 18.4223C47.1939 18.6565 47.3826 18.833 47.6069 18.9229C48.3767 19.2317 48.9203 19.9849 48.9203 20.8651C48.9203 21.7453 48.3767 22.4985 47.6069 22.8073ZM45.3383 20.8651C45.3383 25.1691 41.8493 28.6581 37.5453 28.6581C33.2414 28.6581 29.7523 25.1691 29.7523 20.8651C29.7523 16.5612 33.2414 13.0722 37.5453 13.0722C41.8493 13.0722 45.3383 16.5612 45.3383 20.8651Z",
    fill: "url(#paint18_radial_713_10137)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_713_10137)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.5449,
    cy: 20.8652,
    r: 9.01406,
    stroke: "url(#paint19_linear_713_10137)",
    strokeWidth: 0.2
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_713_10137)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.448,
    cy: 20.2499,
    rx: 1.01719,
    ry: 0.929687,
    transform: "rotate(44.538 47.448 20.2499)",
    fill: "url(#paint20_linear_713_10137)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_713_10137",
    x: 39.3945,
    y: 37.1741,
    width: 8.38086,
    height: 7.98804,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_713_10137"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_713_10137",
    x: 28.4844,
    y: 6.11157,
    width: 14.3711,
    height: 6.89648,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_713_10137"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_713_10137",
    x: 9.60156,
    y: 9.67383,
    width: 14.3711,
    height: 6.89648,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_713_10137"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_713_10137",
    x: 25.459,
    y: 12.5645,
    width: 20.4199,
    height: 20.4197,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_713_10137"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_713_10137",
    x: 8.88281,
    y: 13.4426,
    width: 16.3672,
    height: 16.3672,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_713_10137"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_713_10137",
    x: 41.8711,
    y: 17.9082,
    width: 5,
    height: 29.6157,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_713_10137"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_713_10137",
    x: 28.1316,
    y: 11.4512,
    width: 18.8266,
    height: 18.828,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15,
    result: "effect1_foregroundBlur_713_10137"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_713_10137",
    x: 46.2227,
    y: 19.0261,
    width: 2.45117,
    height: 2.44751,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_713_10137"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_713_10137",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.625 15.75) rotate(132.839) scale(65.6308)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474827,
    stopColor: "#FFB02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F70A8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_713_10137",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.625 15.75) rotate(131.878) scale(68.1602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474827,
    stopColor: "#FFB02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F70A8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_713_10137",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28 21.875) rotate(101.31) scale(31.2315 40.0016)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.787821,
    stopColor: "#F59639",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972509,
    stopColor: "#FF7DCE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_713_10137",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.5 24.5) rotate(135) scale(71.7713)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314853,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_713_10137",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28 29.75) rotate(77.692) scale(49.2571)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.507903,
    stopColor: "#7D6133",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#715B32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_713_10137",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.875 28.875) rotate(55.7131) scale(23.2987 16.8881)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB847",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_713_10137",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.875 31.5) rotate(9.86581) scale(20.4271)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA64B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.900412,
    stopColor: "#FFAE46",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_713_10137",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.625 26.25) rotate(43.9708) scale(103.343)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.185425,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_713_10137",
    x1: 46.3503,
    y1: 46.3743,
    x2: 43.4811,
    y2: 43.7365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B95A2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D46A37",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_713_10137",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.7862 14.1185) rotate(-82.5602) scale(13.5812 27.2883)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.069602,
    stopColor: "#2E1529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29711,
    stopColor: "#5F4357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.437882,
    stopColor: "#4B2744"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_713_10137",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.0486 9.39811) rotate(-90.9301) scale(11.4785 21.3252)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.069602,
    stopColor: "#2E1529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29711,
    stopColor: "#5F4357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.437882,
    stopColor: "#4B2744"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_713_10137",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.9983 28.7079) rotate(88.3713) scale(26.703 28.5326)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.069602,
    stopColor: "#2E1529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29711,
    stopColor: "#5F4357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.437882,
    stopColor: "#4B2744"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_713_10137",
    x1: 47.762,
    y1: 21.6582,
    x2: 41.4402,
    y2: 22.8853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAC6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9B2C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_713_10137",
    x1: 48.9203,
    y1: 34.0723,
    x2: 45.7211,
    y2: 34.0723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C8693",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C8693"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_713_10137",
    x1: 49.768,
    y1: 14.3301,
    x2: 42.539,
    y2: 15.8175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.67927,
    stopColor: "#B08CD2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB96DE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_713_10137",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.2055 18.4862) rotate(116.114) scale(13.667 14.6907)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A09DA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#938D9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_713_10137",
    x1: 39.9242,
    y1: 22.9159,
    x2: 48.9203,
    y2: 33.2519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C8693",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C8693"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_713_10137",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.432 13.7284) rotate(106.682) scale(16.9558 16.5889)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.67927,
    stopColor: "#987AB5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#987AB5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_713_10137",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.0805 27.5644) rotate(-62.4364) scale(11.2275 20.3701)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#837890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208333,
    stopColor: "#837890",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_713_10137",
    x1: 43.1126,
    y1: 11.2588,
    x2: 37.9776,
    y2: 25.0482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5AEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5AEBE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_713_10137",
    x1: 47.1141,
    y1: 19.2166,
    x2: 47.284,
    y2: 21.3195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5AEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5AEBE",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinciples2);
export default __webpack_public_path__ + "static/media/principles2.56940c22e7c5152531ff45b586d39c98.svg";
export { ForwardRef as ReactComponent };